const useTitle = ({ title }) => {
  document.title = title;
  return null;
};

export default useTitle;
